export const llswitch = {
    button: {
        background: "black",
    },
    nougat: {
        background: "cyan",
    }
}